import React, { useState } from 'react';
import MenuItem from './MenuItem';

const MainMenu = ({
  activeItem,
  setActiveItem
}) => {
  let menuList = [
    { key: 'dashboard', title: 'Dashboard', link: '#dashboard', icon: 'home', isActive: true, iconPosition: 'left', className: '' },
    { key: 'widgets', title: 'Widgets', link: '#widgets', icon: 'dashboard-square', isActive: false, iconPosition: 'left', className: '' },
    { key: 'extensions', title: 'Extensions', link: '#extensions', icon: 'extensions', isActive: false, iconPosition: 'left', className: '' },
    { key: 'settings', title: 'Settings', link: '#settings', icon: 'settings', isActive: false, iconPosition: 'left', className: '' },
    { key: 'free-vs-pro', title: 'Free Vs Pro', link: '#freevspro', icon: '', isActive: false, iconPosition: '', className: '' },
    { key: 'unlock-pro', title: 'Unlock Pro Features', link: window.thhaAdminSettings.pricing, icon: 'external-link', isActive: false, iconPosition: 'right', className: 'externel-link', target: '_blank', rel: 'noopener noreferrer' },
  ];

  // Filter out unlock-pro if pro plugin is activated
  if (window.thhaAdminSettings.is_pro_active) {
    menuList = menuList.filter(item => item.key !== 'unlock-pro');
  }

  return (
    <div className="menuwrap">
      <ul className="menu-list">
        {menuList.map((item) => (
          <MenuItem
            key={item.key}
            item={item}
            isActive={activeItem === item.key}
            onClick={item.target === '_blank' ? null : () => setActiveItem(item.key)} // Only set active for internal links
          />
        ))}
      </ul>
    </div>
  );
};

export default MainMenu;
